<template>
    <div>
        <PageBanner :pageTitle="$t('sidebar_hollywoodsmile_one')" />

        <HollywoodSmilePurpose />
    </div>
</template>

<script>

import HollywoodSmilePurpose from '../blog-details/HollywoodSmilePurpose'
import PageBanner from '../Common/PageBanner'

export default {
    components: {
        PageBanner,
        HollywoodSmilePurpose,
    }
}
</script>